import GoogleDriveConfig from 'documents-ui/lib/GoogleDriveConfig';
import { addAlert } from 'documents-lib/js/utils/addAlert';
export default (({
  authToken,
  useMultiSelect,
  onSelect
}) => {
  const {
    google,
    gapi
  } = window;
  if (!google || !google.picker) {
    throw new Error('google.picker undefined after authenticating');
  }
  const multiSelectFeature = useMultiSelect ? google.picker.Feature.MULTISELECT_ENABLED : '';
  const handleGetFileFailure = name => __response => {
    addAlert('importFileFromDrive', 'danger', {
      name
    });
  };
  const handleUrlRequest = ({
    result
  }) => {
    let {
      title,
      downloadUrl,
      exportLinks,
      // eslint-disable-line prefer-const
      capabilities: {
        canCopy
      } // eslint-disable-line prefer-const
    } = result;
    if (!canCopy) {
      addAlert('driveFileNotCopyable', 'danger', {
        name: title
      });
      return;
    }
    if (exportLinks) {
      const exportLinksValues = Object.values(exportLinks || {});
      downloadUrl = exportLinksValues.find(link => /pptx$/.test(link));
      title = `${title}.pptx`;
    }

    // https://git.hubteam.com/HubSpot/Presentations/issues/772
    downloadUrl = downloadUrl.replace('content.googleapis.com', 'www.googleapis.com');
    onSelect({
      name: title,
      link: downloadUrl,
      accessToken: authToken
    });
  };
  const picker = new google.picker.PickerBuilder().addView(google.picker.ViewId.PRESENTATIONS).addView(google.picker.ViewId.PDFS).enableFeature(multiSelectFeature).enableFeature(google.picker.Feature.SUPPORT_DRIVES).setAppId(GoogleDriveConfig().applicationId).setOAuthToken(authToken).setDeveloperKey(GoogleDriveConfig().developerKey).setCallback(data => {
    if (data.action !== google.picker.Action.PICKED) {
      return;
    }
    data.docs.forEach(doc => {
      const request = gapi.client.drive.files.get({
        fileId: doc.id,
        supportsAllDrives: true
      });
      request.then(handleUrlRequest).catch(() => {
        handleGetFileFailure(doc.name);
      });
    });
  }).build();
  picker.setVisible(true);
});